var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "flex-direction": "column" } },
    [
      _c("so-no-input", {
        staticStyle: { "margin-bottom": "5px" },
        attrs: { disabled: _vm.disabled },
        on: {
          change: function($event) {
            return _vm.onChange("jobSoNo")
          }
        },
        model: {
          value: _vm.job.jobSoNo,
          callback: function($$v) {
            _vm.$set(_vm.job, "jobSoNo", $$v)
          },
          expression: "job.jobSoNo"
        }
      }),
      _c(
        "el-checkbox",
        {
          on: {
            change: function($event) {
              return _vm.onChange("predictionOperation")
            }
          },
          model: {
            value: _vm.job.predictionOperation,
            callback: function($$v) {
              _vm.$set(_vm.job, "predictionOperation", $$v)
            },
            expression: "job.predictionOperation"
          }
        },
        [_vm._v(_vm._s(_vm.$t("SeaExport.PreAlertOperation")))]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }